import { AnalogInput } from 'z3k-config';
export const sensor_defaults_on_create = {
    sensor_type: AnalogInput.Type.ANALOG_INPUT,
    title: 'Аналоговый вход',
    defaults: {
        upper_threshold: 0,
        lower_threshold: 0,
        active_level_timeout: 1,
        inactive_level_timeout: 2,
        setting_register: 0,
    },
    min_firmware_version: 0,
};
export const sensor_defaults = [
    sensor_defaults_on_create,
    {
        sensor_type: AnalogInput.Type.PRESSURE_SENSOR_5,
        title: 'Датчик давления HK3022 5 бар',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 4,
            lower_threshold: 1,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.PRESSURE_SENSOR_12,
        title: 'Датчик давления HK3022 12 бар',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 11,
            lower_threshold: 1,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.PRESSURE_SENSOR_MLD_6,
        title: 'Датчик давления MLD-06',
        min_firmware_version: 210,
        defaults: {
            upper_threshold: 5,
            lower_threshold: 1,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.MAGNET,
        title: 'Магнитный датчик открывания двери/окна',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.MOTION_CONTROLLED,
        title: 'ИК датчик движения с контролем шлейфа',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.SMOKE,
        title: 'Датчик дыма',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.LEAK,
        title: 'Датчик протечки',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.MOTION_UNCONTROLLED,
        title: 'ИК датчик движения без контроля шлейфа',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.THERMOSTAT,
        title: 'Комнатный термостат',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.BOILER_FAILURE_PLUS,
        title: 'Авария котла +',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.BOILER_FAILURE_MINUS,
        title: 'Авария котла -',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.IGNITION,
        title: 'Вход зажигание',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 0.3,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.SPEED_SENSOR,
        title: 'Датчик скорости',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.RPM_SENSOR,
        title: 'Датчик оборотов двигателя',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.DISCRETE,
        title: 'Дискретный вход',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.ALARM_BUTTON,
        title: 'Тревожная кнопка',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.FUEL_STAT_SENSOR,
        title: 'Датчик расхода топлива',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.HUMIDITY_SENSOR,
        title: 'Датчик влажности воздуха',
        min_firmware_version: 0,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.ANALOG_DISCRETE_SENSOR_NO,
        title: 'Дискретный вход нормально разомкнутый',
        min_firmware_version: 341,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.ANALOG_DISCRETE_SENSOR_NC,
        title: 'Дискретный вход нормально замкнутый',
        min_firmware_version: 341,
        defaults: {
            upper_threshold: 0,
            lower_threshold: 0,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
    {
        sensor_type: AnalogInput.Type.PRESSURE_SENSOR_MLD_10,
        title: 'Датчик давления МЛД-10/МЛД-10.01 10 бар',
        min_firmware_version: 475,
        defaults: {
            upper_threshold: 9,
            lower_threshold: 1,
            active_level_timeout: 1,
            inactive_level_timeout: 2,
            setting_register: 0,
        },
    },
];
